var _a;
import ValueBase from "./ValueBase";
class Range {
    min;
    max;
    minimum;
    maximum;
    qualifier;
    constructor(response) {
        this.min = response.min !== undefined ? new ValueBase(response.min) : undefined;
        this.max = response.max !== undefined ? new ValueBase(response.max) : undefined;
        this.minimum = response.minimum;
        this.maximum = response.maximum;
        this.qualifier = response.qualifier;
    }
    printPrice() {
        const items = [];
        if (this.min?.value !== undefined && this.max?.value !== undefined) {
            items.push(`${this.min.printPrice(" ").join(" ")} - ${this.max.printPrice("%").join(" ")}`);
        }
        if (this.qualifier !== undefined) {
            items.push(this.qualifier);
        }
        return items;
    }
    printYield() {
        const items = [];
        if (this.min !== undefined && this.max !== undefined) {
            items.push(`${this.min.printYield("").join(" ")} - ${this.max.printYield("%").join(" ")}`);
        }
        if (this.qualifier !== undefined) {
            items.push(this.qualifier);
        }
        return items;
    }
    printSpread() {
        const items = [];
        if (this.min?.value !== undefined && this.max?.value !== undefined) {
            items.push(`${this.min.value > 0 ? '+' : ''}${this.min.printSpread().join(" ")} - ${this.max.printSpread().join(" ")}`);
        }
        if (this.qualifier !== undefined) {
            switch (this.qualifier) {
                case "AREA":
                    items.push('area');
                    break;
                case "MAX":
                    items.push('max.');
                    break;
                case "WPIR":
                    items.push('WPIR');
                    ;
                    break;
            }
        }
        return items;
    }
    #clone() {
        return new _a(this);
    }
    updateMin(newValue) {
        const clone = this.#clone();
        clone.min = newValue;
        return clone;
    }
    updateMax(newValue) {
        const clone = this.#clone();
        clone.max = newValue;
        return clone;
    }
    updateQualifier(newValue) {
        const clone = this.#clone();
        clone.qualifier = newValue;
        return clone;
    }
}
_a = Range;
export default Range;
